
// 定义可能的 key 作为枚举，增强类型安全
export enum CallJSSKey {
    GeoRequestFingerprint = "geo_request_fingerprint",
    GeoRequestLocation = "geo_request_location",
    GeoQueryGps = "geo_query_gps",
    HideIframeDialog = "HideIframeDialog",
    SetForcedLandscape = "setForcedLandscape",
    CloseOpener = "closeOpener",
    HideLoading = "hideLoading",
    ShowKeyboard = "showKeyboard",
    HideKeyboard = "hideKeyboard",
    InstallPWA = "installPWA",
    JumpPay = "jumpPay",
    JumpEmail = "jumpEmail",
    JumpUrl = "jumpUrl",
    Url = "url",
    TrackChannel = "trackChannel",
    TrackThirdChannel = "trackThirdChannel",
    TrackGA4 = "trackGA4",
    TrackFirebaseEvent = "track_firebase_event",
    TrackPixel = "trackPixel",
    TrackAdjust = "trackAdjust",
    Track = "track",
    WebDB = "web_db",
    Tsetsi = "tsetsi",
    Golsi = "golsi",
    Development = "development",
    IsInstalledPwa = "isInstalledPwa",
    IsPlayPwa = "isPlayPwa",
    IsDesktop = "isDesktop",
    IsIOS = "isIOS",
    IsAndroid = "isAndroid",
    IsGuidePwa = "isGuidePwa",
    WebDBOpen = "web_db_open",
    IsGeoReady = "is_geo_ready",
    IsGeoOpen = "is_geo_open",
    IsGpsPermiReady = "is_gps_permi_ready",
    IsGpsPermiOpen = "is_gps_permi_open",
    IsUserBuy = "att_isUserBuy",
    Config = "config",
    GameInitJson = "GameInitJson",
    Header = "header",
    GameId = "gameId",
    GetSMID = "getSMID",
    GetAdjustAttr = "getAdjustAttr",
    GetSystemLanguage = "getSystemLanguage",
    GetSystemCountry = "getSystemCountry",
    GetSystemVersion = "getSystemVersion",
    GetDeviceModelName = "getDeviceModelName",
    GetDeviceBrand = "getDeviceBrand",
    GetWebUUID = "getWebUUID",
    WebId = "webId",
    GaId = "gaId",
    GetSdkCfgStr = "config_stringValue",
    GetSdkCfgInt = "config_intValue",
    H5AppName = "h5_app_name",
    H5PackageName = "h5_package_name",
    H5VersionName = "h5_version_name",
    H5VersionCode = "h5_version_code",
    H5Mode = "h5_mode",
    GetGeoEncrypt = "getGeoEncrypt",
    GetGeoLocation = "getGeoLocation",
    GetGpsPermiState = "getGpsPermiState",
    OnDocumentHidden = "OnDocumentHidden",
    OnDocumentVisible = "OnDocumentVisible",

    //--getStr方法
    PlayerLevel = 'player_level',//玩家等级
    VipLevel = 'vip_level',//玩家等级
    TimeZone = 'time_zone',//时区
    OpenMoney = 'open_money',//网站开关
    productId = 'productId',//产品ID
    releaseProductId = 'releaseProductId',
    rewardType = 'reward_type',
    WebUserGlobalData = "web_user_global_data",//WEB用户的全局信息
    // //是否强制横屏
    // forceHorizontal = 'force_horizontal',
    //当前设备方向 1=横屏幕 2竖屏
    deviceOrientation = 'device_orientation',

    // -- Do方法
    LoadProgress = "load_progress",//页面加载进度
    OpenShop = "open_shop",//打开商店
    OpenRedeem = "open_redeem",
    NoMoney = "no_money",//没钱弹窗
    BackToMain = "back_to_main",//返回到主页面
    TokenExpired = "token_expired",//token过期。跳转到登陆页面

    SyncData = "sync_data",//强制通知unity同步
    BackToGame = "back_to_game",//回到游戏
    LayoutRefresh = "layout_refresh",//页面大小改变时

    // -- Set方法
    track_commit = "track_commit",//埋点统计方法

    //IS方法
    loginAccountOk = "login_account_ok",//是否是帐号登录


}